(() => {
if (window.__sfjCards) return;
window.__sfjCards = true;
document.addEventListener('scroll', (e) => {
const track = e.target;
if (!track.classList || !track.classList.contains('sfj-card__track')) return;
const i = Math.round(track.scrollLeft / track.clientWidth);
const dots = track.parentElement.querySelectorAll('.sfj-card__dots i');
dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
}, true);
const canHover = window.matchMedia('(hover: hover)').matches;
if (canHover) {
document.addEventListener('mouseover', (e) => {
const card = e.target.closest && e.target.closest('.sfj-card');
if (!card || card.dataset.hov) return;
card.dataset.hov = '1';
const t = card.querySelector('.sfj-card__track');
if (t && t.children.length > 1) t.scrollTo({ left: t.clientWidth, behavior: 'smooth' });
});
document.addEventListener('mouseout', (e) => {
const card = e.target.closest && e.target.closest('.sfj-card');
if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
delete card.dataset.hov;
const t = card.querySelector('.sfj-card__track');
if (t) t.scrollTo({ left: 0, behavior: 'smooth' });
});
}
const addToCart = async (id, btn) => {
btn.classList.add('is-loading');
try {
const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
if (!r.ok) throw new Error('add failed');
btn.classList.remove('is-loading');
btn.classList.add('is-done');
document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { variantId: Number(id) } }));
document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')), 250);
setTimeout(() => { btn.classList.remove('is-done'); const c = btn.closest('.sfj-card'); if (c) c.classList.remove('is-qa'); }, 1200);
} catch (err) {
btn.classList.remove('is-loading');
const card = btn.closest('.sfj-card');
if (card && card.dataset.url) window.location.href = card.dataset.url;
}
};
document.addEventListener('click', (e) => {
const add = e.target.closest('[data-sfj-add]');
if (add) {
e.preventDefault();
if (add.dataset.variant) return addToCart(add.dataset.variant, add);
const card = add.closest('.sfj-card');
document.querySelectorAll('.sfj-card.is-qa').forEach(c => c !== card && c.classList.remove('is-qa'));
card.classList.toggle('is-qa');
return;
}
const v = e.target.closest('[data-sfj-variant]');
if (v) { e.preventDefault(); return addToCart(v.dataset.sfjVariant, v); }
if (e.target.closest('[data-sfj-qa-close]')) { e.preventDefault(); e.target.closest('.sfj-card').classList.remove('is-qa'); return; }
if (!e.target.closest('.sfj-card__qa')) document.querySelectorAll('.sfj-card.is-qa').forEach(c => c.classList.remove('is-qa'));
const tab = e.target.closest('[data-sfj-tab]');
if (tab) {
const s = tab.closest('[data-sfj-pt]');
s.querySelectorAll('[data-sfj-tab]').forEach(t => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
s.querySelectorAll('[data-sfj-panel]').forEach(p => p.classList.toggle('is-active', p.dataset.sfjPanel === tab.dataset.sfjTab));
s.querySelector('[data-sfj-title]').textContent = tab.dataset.title;
s.querySelector('[data-sfj-count]').textContent = tab.dataset.count;
const all = s.querySelector('[data-sfj-all]'); if (all) all.href = tab.dataset.url;
return;
}
const view = e.target.closest('[data-sfj-view]');
if (view) {
const s = view.closest('[data-sfj-pt]');
const next = ((Number(s.dataset.view || 1)) % 3) + 1;
s.dataset.view = next;
view.querySelectorAll('.sfj-pt__boxes i').forEach((b, n) => b.classList.toggle('is-on', n === next - 1));
return;
}
const model = e.target.closest('[data-sfj-model]');
if (model) {
const s = model.closest('[data-sfj-pt]');
const on = !s.classList.contains('is-model');
s.classList.toggle('is-model', on);
model.setAttribute('aria-pressed', on);
}
});
})();